import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ToastService } from '../../../_core/services/toast.service';
import { Tournament } from '../../../_shared/models/tournament.model';
import { TournamentDetailsService } from '../tournament-details.service';

@Component({
    selector: 'app-tournament-announcement',
    templateUrl: './tournament-announcement.component.html',
    styleUrls: ['./tournament-announcement.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        FormsModule,
        TranslateModule
    ]
})
export class TournamentAnnouncementComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    private tournamentDetailsService = inject(TournamentDetailsService);
    private toastService = inject(ToastService);
    private translateService = inject(TranslateService);
    private modalController = inject(ModalController);

    @Input() tournament: Tournament;
    @Input() isOwner: boolean = false;

    message: string = '';
    enabled: boolean = false;
    isSaving: boolean = false;

    ngOnInit() {
        if (this.tournament) {
            this.message = this.tournament.announcement?.message || '';
            this.enabled = this.tournament.announcement?.enabled || false;
        }
    }

    saveAnnouncement() {
        if (!this.tournament?._id) return;
        
        this.isSaving = true;
        this.tournamentDetailsService
            .updateAnnouncement(this.tournament._id, this.message, this.enabled)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                finalize(() => this.isSaving = false)
            )
            .subscribe({
                next: () => {
                    this.tournament.announcement = { message: this.message, enabled: this.enabled };
                    this.toastService.presentToast(this.translateService.instant('Announcement updated successfully'));
                    this.modalController.dismiss({
                        updated: true,
                        announcement: { message: this.message, enabled: this.enabled }
                    });
                },
                error: (err) => {
                    const errorMessage = err.error?.message || this.translateService.instant('Failed to update announcement');
                    this.toastService.presentDangerToast(errorMessage);
                }
            });
    }

    dismiss() {
        this.modalController.dismiss();
    }
}
